<template>
  <div class="theme__list-row-sentiment-charts">
    <PositiveNegativeBarChartSmall :value="posNegData">
      <template #description="{ chartDescription }">
        <details class="chart-description__details">
          <summary>
            <span class="sr-only"><VisibleText>theme</VisibleText> {{ themeName }} </span>
            <VisibleText>chart details</VisibleText>
          </summary>
          <p class="chart-description__details-text" v-html="chartDescription"></p>
        </details>
      </template>
    </PositiveNegativeBarChartSmall>
  </div>
</template>

<script>
import { PigeonDocNodeModel, PositiveNegativeBarChartSmall } from '@/pigeondoc/wrapper';

export default {
  name: 'SentimentCharts',
  components: {
    PositiveNegativeBarChartSmall,
  },
  props: {
    themeName: {
      type: String,
      default: () => '',
    },
    singleStackData: {
      type: PigeonDocNodeModel,
      default: () => {},
    },
    posNegData: {
      type: PigeonDocNodeModel,
      default: () => {},
    },
  },
  watch: {
    themeName: function (val) {
      if (!val) return;
      this.$forceUpdate();
    },
  },
};
</script>
